import React, { useEffect, useState } from 'react'
import {
    AccordionSummary,
    AccordionDetails,
   
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from '../../../component/addCategoryForm/addCategoryForm.module.css';

import { useDispatch, useSelector } from 'react-redux';
import {  getTopCategoriesThunk } from '../../../redux/appearanceSlice';
import { toast } from 'react-toastify';


const CategoryView = ({ Accordions, handleChange, expanded }) => {
    const [selectedCategories, setSelectedCategories] = useState([])
    const { categoryHeirarchy } = useSelector((state) => state.categoryHeirarchy);
    const { categories ,refresh} = useSelector((state) => state.appearances)

    const dispatch = useDispatch()


    useEffect(() => {
        dispatch(getTopCategoriesThunk())
    }, [refresh])

    useEffect(()=>{
       setSelectedCategories(categories?.data)
    },[categories])
    
    return (
        <Accordions sx={{ marginBottom: "20px" }}
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography sx={{
                    fontSize: "16px",
                    color: "#1D1F2C",
                }}>Categories</Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ background: '#F0F1F3B2', margin: "0px 20px 20px 20px" }}>
                <div>
                    <label className={styles.addCatLabel}>
                        Categories
                    </label>

                    {/* <div className={stylesp.customSelect}>
                        <div
                            className={styles.addCatSelect} style={{ paddingTop: "11px" }}
                        >
                            Select
                        </div>
                      
                    </div> */}


                    {/* <p className={styles.addCatLabel} style={{ margin: "15px 0" }}>You can select category that you want to show upto 14 categories</p> */}

                    <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 10, gap: 10, }}>
                        {
                            selectedCategories?.map((i) => (
                                <div className={styles.selectedname}>
                                    {i?.name}
                                    
                                </div>
                            ))
                        }
                    </div>

                 
                </div>
            </AccordionDetails>
        </Accordions>
    )
}

export default CategoryView